export default (function (doc, win) {
  // var isAndroid = win.navigator.appVersion.match(/android/gi)
  var isIPhone = win.navigator.appVersion.match(/iphone/gi)
  var scale = 1.0
  // var ratio = 1
  // if (isIPhone) {
  //   if (window.devicePixelRatio == 2) {
  //     scale *= 0.5
  //     // ratio *= 2
  //   }
  //   if (window.devicePixelRatio == 3) {
  //     scale *= (1 / 3)
  //     // ratio *= 3
  //   }
  // }
  var text =
    '<meta name="viewport" content="initial-scale=' +
    scale +
    ', maximum-scale=' +
    scale +
    ',' +
    ' minimum-scale=' +
    scale +
    ', width=device-width,' +
    ' user-scalable=no" />'
  document.write(text)
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    var clientHeight = Math.floor(docEl.clientHeight)
    if (!clientWidth) return
    if (clientWidth <= 320) {
      clientWidth = 320
    }

    console.log(clientWidth)
    // Android.Vuetrace(clientWidth);
    // Android.Vuetrace(clientHeight);
    if (clientHeight == 846 && clientWidth == 412) {
      docEl.style.fontSize = 100 * (clientWidth / 682) + 'px'
    } else if (clientHeight == 640 && clientWidth == 384) {
      docEl.style.fontSize = 100 * (clientWidth / 710) + 'px'
    } else if (clientHeight == 1024 && clientWidth == 768) {
      docEl.style.fontSize = 100 * (clientWidth / 1024) + 'px'
    } else {
      docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
    }
    // 解决部分rem特别大的问题
    var docElFontSize = docEl.style.fontSize.replace(/px/gi, '')
    var computedFontSize = win.getComputedStyle(docEl)['font-size'].replace(/px/gi, '')
    docElFontSize != computedFontSize &&
      (docEl.style.fontSize = (docElFontSize * docElFontSize) / computedFontSize + 'px')
    window.fs = docEl.style.fontSize = (docElFontSize * docElFontSize) / computedFontSize
  }

  if (!doc.addEventListener) return
  if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { // 移动端
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  }
})(document, window)
